var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BusinessAmount"},[_c('BarChartDisplay',{attrs:{"title":_vm.$t('business.quantity-sector'),"options":_vm.sectorsData,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }